import { Pencil1Icon } from "@radix-ui/react-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetAcademicPeriodQuery } from "../../hooks/useGetAcademicPeriodQuery";
import { setUpdateAcademicPeriodData } from "../../redux/slices/school/academicPeriod";
import { routes } from "../../routes";
import { AcademicPeriodType } from "../../types/AcademicPeriod";
import { stringToDate } from "../../utils/dateFormatter";


const columnNamesMap: { [key: string]: string } = {
    _startFirstSemester: 'Início 1º Semestre',
    _endFirstSemester: 'Fim 1º Semestre',
    _startSecondSemester: 'Início 2º Semestre',
    _endSecondSemester: 'Fim 2º Semestre',
    startAdmissionExam: 'Início Exames de Admissão',
    endAdmissionExam: 'Fim Exames de Admissão',
};
export const AcademicPeriods = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { data, status } = useGetAcademicPeriodQuery({ PageNumber: currentPage, PageSize: 400 });
    // const { data:academicYearData, status: academicYearStatus, isLoading: academicYearLoading } = useGetCurrentAcademicYearQuery();


    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createAcademicPeriod)
    }
    const handleEdit = (academicPeriod: AcademicPeriodType) => {
        dispatch(setUpdateAcademicPeriodData(academicPeriod));
        navigate(routes.updateAcademicPeriod)
    };



    const options = data?.items.map(() => [
        {
            label: 'Editar',
            onClick: (academicPeriod: AcademicPeriodType) => handleEdit(academicPeriod),
            icon: <Pencil1Icon />
        },
    ]) || [];

    return (
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={['_startFirstSemester', '_endFirstSemester', '_startSecondSemester', '_endSecondSemester']}
                    items={data?.items.map(i => {
                        return {
                            ...i,
                            _startFirstSemester: stringToDate(i.startFirstSemester),
                            _endFirstSemester: stringToDate(i.endFirstSemester),
                            _startSecondSemester: stringToDate(i.startSecondSemester),
                            _endSecondSemester: stringToDate(i.endSecondSemester),
                        }
                    })}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleClickCreate}
        />
    );
}